export const STATUS_TYPES = {
    LOADING: 'loading',
    READING_DOCUMENTS: 'reading_documents',
    READING_DOCUMENT: 'reading_document',
    THINKING: 'thinking',
    FINDING_TOOLS: 'finding_tools',
};

export const STATUS_MESSAGES = {
    [STATUS_TYPES.LOADING]: 'Loading...',
    [STATUS_TYPES.READING_DOCUMENTS]: 'Reading documents...',
    [STATUS_TYPES.READING_DOCUMENT]: 'Reading document...',
    [STATUS_TYPES.THINKING]: 'Thinking...',
    [STATUS_TYPES.FINDING_TOOLS]: 'Finding tools...',
};
